import { render, staticRenderFns } from "./FileEditor.vue?vue&type=template&id=fc76cbce"
import script from "./FileEditor.vue?vue&type=script&lang=js"
export * from "./FileEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports